<div mat-dialog-content id="dialog" class="centrado">
    <p> {{title}} </p>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    <mat-progress-bar color="primary" [value]="percentage" class="mat-progress-bar-buffer" mode="determinate"></mat-progress-bar>
</div>
